import React, { useEffect, useState } from "react";
import { api } from "@/lib/config";
import { FileText, Quote, Download, MessageSquare } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ blog: 0, testimonials: 0, resources: 0, messages: 0, unread: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/admin/blog").catch(() => ({ data: [] })),
      api.get("/testimonials").catch(() => ({ data: [] })),
      api.get("/resources").catch(() => ({ data: [] })),
      api.get("/admin/messages").catch(() => ({ data: [] })),
    ]).then(([b, t, r, m]) => {
      setStats({
        blog: b.data.length,
        testimonials: t.data.length,
        resources: r.data.length,
        messages: m.data.length,
        unread: m.data.filter(x => !x.handled).length,
      });
    });
  }, []);

  const cards = [
    { label: "Articles publiés", value: stats.blog, icon: FileText, color: "bg-brand text-white" },
    { label: "Témoignages", value: stats.testimonials, icon: Quote, color: "bg-paper border border-ink/10" },
    { label: "Ressources", value: stats.resources, icon: Download, color: "bg-paper border border-ink/10" },
    { label: "Messages reçus", value: stats.messages, icon: MessageSquare, color: "bg-accent-pink text-white", badge: stats.unread },
  ];

  return (
    <div>
      <p className="section-num">Tableau de bord</p>
      <h1 className="display text-4xl mt-3">Bienvenue.</h1>
      <p className="text-ink/60 mt-3">Vue d'ensemble du contenu et des derniers messages reçus.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
        {cards.map(c => (
          <div key={c.label} className={`p-8 ${c.color}`}>
            <c.icon size={20}/>
            <p className="display text-5xl mt-6">{c.value}</p>
            <div className="flex items-center justify-between mt-2">
              <p className="text-sm">{c.label}</p>
              {c.badge > 0 && <span className="bg-brand text-white text-xs px-2 py-1 rounded-full">{c.badge} nouveaux</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
